export const ACCESS_TOKEN_NAME = 'ACCESS_TOKEN'
export const USER_INFO_NAME = 'USER_INFO'
export const UPYUN_URL = 'https://upyun.hokori.online'
